import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cohrex-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PageTitleComponent {}
